import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject, debounceTime } from "rxjs";
import { RemoveFranchiseSuspension } from "src/app/admin/models/franchise-admin-list";
import { FranchisesAdminService } from "src/app/admin/services/franchises-admin.service";
import { StorageService } from "src/app/admin/services/storage.services";
import { BaseComponent } from "src/app/shared/base/base-component";

@Component({
  selector: "app-franchise-raise-actions-modal",
  templateUrl: "./franchise-raise-actions-modal.component.html",
  styleUrls: ["./franchise-raise-actions-modal.component.scss"],
})
export class FranchiseRaiseActionsModalComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() public modalType: any;
  @Input() public franchiseNo: any;
  @Input() public franchiseId: any;
  private _error = new Subject<string>();
  errorMessage: string | null;
  constructor(private franchisesAdminService: FranchisesAdminService,
    private storageService: StorageService) {
    super();
  }

  ngOnInit(): void {
    //========================== Messages ==========================
    this._error.subscribe((message) => (this.errorMessage = message));
    this._error
      .pipe(debounceTime(7000))
      .subscribe(() => (this.errorMessage = null));
    //==============================================================
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  close() {
    this.modalService.dismissAll();
  }

  save(note: any): void {
    // console.log("modal notes " + note.value);
    // debugger;
    if (note.value === '' || note.value === null || note.value === undefined) {
      this._error.next('من فضلك ادخل السبب');
      return;
    }

    if (note.value.length < 10 || note.value.length > 150) {
      this._error.next('من فضلك ادخل السبب ما بين 10 احرف و 150 حرف');
      return;
    }

    let model = {} as RemoveFranchiseSuspension;

    model.franchiseId = this.franchiseId;
    model.cancelSuspensionReasonDesc = note.value;

    console.log("remove franchise suspension " + JSON.stringify(model));

    var ob = this.modalType === 'raiseViolation' ? this.franchisesAdminService.removeViolatedFranchise(model)
      : this.franchisesAdminService.removeSuspensionFranchise(model);

    const sub = ob.subscribe(() => {
      const message = "AdminFranchise.CancelSuspended";
      this.storageService.addAlertMessageInSessionStorage({
        key: "success",
        value: message,
      });
      this.close();
      location.reload();
    },
      (error) => {
        if (error.status == "403")
          this._error.next(error.error.error.message);
        else
          this.translate
            .get("ErrorCodes.CreateError")
            .subscribe((msg) => this._error.next(msg));
      });

    this.subscription.push(sub);
  }
}